import React from 'react';

import { Action, Actions } from '@gogame/components';

import { useExportInvoices } from '../../data/mutations';

const FinancialResulBulkActions = ({ selectedValues }) => {
  const [exportInvoices] = useExportInvoices();
  const handleExportSelectedInvoices = async () => {
    await exportInvoices({ financialResultIds: selectedValues });
  };

  return (
    <Actions>
      <Action
        button={true}
        label={'Export Invoices'}
        onClick={handleExportSelectedInvoices}
      />
    </Actions>
  );
};

export default FinancialResulBulkActions;
